import React, { useEffect, useState } from 'react';

// Pagination footer for every list, laid out like the AiventraLMS table footer
// (lms-tms-app/frontend/src/components/ui/Table.jsx PaginationBar):
//   "N items"                         [10 / page]  ‹  [ 3 ] / 7  ›
// The number box doubles as jump-to-page (type a number, Enter or click away).
export default function TablePagination({
  total,
  page,
  pageSize,
  onPageChange,
  onPageSizeChange,
  pageSizeOptions = [10, 25, 50, 100],
  itemLabel = 'items',
  className = '',
  style,
}) {
  const totalPages = Math.max(1, Math.ceil((total || 0) / pageSize));
  const [jump, setJump] = useState(String(page));
  useEffect(() => { setJump(String(page)); }, [page]);

  const commitJump = () => {
    const n = Math.min(totalPages, Math.max(1, Math.round(Number(jump)) || 1));
    setJump(String(n));
    if (n !== page) onPageChange(n);
  };

  return (
    <div className={`table-pagination-bar ${className}`} style={style}>
      <span className="whitespace-nowrap">{total} {itemLabel}</span>
      <div className="flex items-center gap-2">
        {onPageSizeChange && (
          <select
            value={pageSize}
            onChange={(e) => onPageSizeChange(Number(e.target.value))}
            className="lms-page-select"
            aria-label="Rows per page"
          >
            {pageSizeOptions.map((n) => <option key={n} value={n}>{n} / page</option>)}
          </select>
        )}
        <button type="button" className="lms-page-btn" disabled={page <= 1} onClick={() => onPageChange(page - 1)} aria-label="Previous page">‹</button>
        <span className="flex items-center gap-1 whitespace-nowrap">
          <input
            type="number"
            min={1}
            max={totalPages}
            value={jump}
            onChange={(e) => setJump(e.target.value)}
            onBlur={commitJump}
            onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); commitJump(); } }}
            className="lms-page-input"
            aria-label="Jump to page"
          />
          <span>/ {totalPages}</span>
        </span>
        <button type="button" className="lms-page-btn" disabled={page >= totalPages} onClick={() => onPageChange(page + 1)} aria-label="Next page">›</button>
      </div>
    </div>
  );
}
